/* eslint-disable react/no-danger */
import { Fragment } from 'react';
import oneLine from 'common-tags/lib/oneLine';

import { Helmet } from 'core/libs/helmet';

/* eslint-disable react/no-danger */
export default {
  getSiteControl: (id, i) => (
    <script key={id + i} dangerouslySetInnerHTML={{
      __html: oneLine`
      (function (w,i,d,g,e,t,s)
      {w[d] = w[d]||[];t= i.createElement(g); t.async=1;t.src=e;s=i.getElementsByTagName(g)[0];s.parentNode.insertBefore(t, s); }
      )(window, document, '_gscq','script','//widgets.getsitecontrol.com/${id}/script.js');
    `,
    }}
    />
  ),

  gnezdo: (id, i) => (
    <script key={id + i} dangerouslySetInnerHTML={{
      __html: `new Image().src = "//news.gnezdo.ru/e/?dr="+escape(document.referrer)+"&du="+escape(document.URL)+"&ui=${id}&"+Math.random();`,
    }}
    />
  ),

  googleAnalytics: {
    default: (id, i) => (
      <script key={id + i} dangerouslySetInnerHTML={{
        __html: oneLine`
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
        ga('create', '${id}', 'auto');
        ga('require', 'displayfeatures');
        ga('send', 'pageview');`,
      }}
      />
    ),
    amp: id => (
      <amp-analytics type='googleanalytics' key={id}>
        <script
          type='application/json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify({
            'vars': {
              'account': id,
            },
            'triggers': {
              'trackPageview': {
                'on': 'visible',
                'request': 'pageview',
              },
            },
          }) }}
        />
      </amp-analytics>
    ),
  },

  ga4: {
    default: (id, i) => (
      <Helmet key={id + i}>
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${id}`} />
        <script dangerouslySetInnerHTML={{
          __html: oneLine`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${id}', {
            send_page_view: false
          });
          gtag('event', 'page_view');`,
        }}
        />
      </Helmet>
    ),
    amp: (id, i) => (
      <Fragment key={id + i}>
        <amp-analytics
          type='gtag'
          data-credentials='include'
        >
          <script
            type='application/json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify({
              'vars': {
                'gtag_id': id,
                'config': {
                  [id]: {
                    'groups': 'default',
                  },
                  'triggers': {
                    'trackScrollThrough': {
                      'on': 'amp-next-page-scroll',
                      'request': 'pageview',
                    },
                    'notBounce': {
                      'on': 'timer',
                      'timerSpec': {
                        'immediate': false,
                        'interval': 15,
                        'maxTimerLength': 16,
                      },
                      'request': 'notBounce',
                    },
                    'trackPageview': {
                      'on': 'visible',
                      'request': 'pageview',
                    },
                  },
                },
              },
            }) }}
          />
        </amp-analytics>
      </Fragment>
    ),
  },

  // GTM должен быть в HEAD, поэтому в Helmet
  // googleTagManager может быть строкой с id или объектом {id:<id>, ...otherParams}
  googleTagManager: (params, i) => {
    const gotIdOnly = (typeof params === 'string' || typeof params === 'number');
    const { id, ...otherParams } = gotIdOnly ? { id: params } : params;
    // если есть другие параметры кроме id добавляем их в otherQueryParamsString
    const otherQueryParamsString = Object.keys(otherParams).map((key) => '&' + key + '=' + params[key]).join('');

    return (
      <Fragment key={params.id + i}>
        <Helmet>
          <script>{oneLine`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'${otherQueryParamsString}';
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${id}');
        `}</script>
        </Helmet>
        <noscript dangerouslySetInnerHTML={{
          __html: oneLine`
        <iframe src="https://www.googletagmanager.com/ns.html?id=${id}${otherQueryParamsString}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `,
        }}
        />
      </Fragment>
    );
  },

  liveInternet: {
    default: (params, i) => {
      const ids = params.ids || [''];
      const images = ids.map(id => (
        `new Image().src = "//counter.yadro.ru/hit${id ? ';' + id : ''}?r" + escape(document.referrer) + ((typeof(screen)=="undefined")?"" : ";s"+screen.width+"*"+screen.height+"*" + (screen.colorDepth?screen.colorDepth:screen.pixelDepth)) + ";u"+escape(document.URL) + ";h"+escape(document.title.substring(0,150)) + ";" +Math.random();`
      ));
      return (
        <script key={'analytics_liveinternet_' + i} dangerouslySetInnerHTML={{
          __html: oneLine`
          var updateLiveInternetCounter;
          (updateLiveInternetCounter = function() {
            ${images.join('')}
          })();`,
        }}
        />
      );
    },
    amp: () => (
      <amp-analytics id='analytics_liveinternet' key='analytics_liveinternet'>
        <script
          type='application/json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify({
            'requests': {
              'pageview': 'https://counter.yadro.ru/hit?u${ampdocUrl};r${documentReferrer};s${screenWidth}*${screenHeight}*32;h${title};${random}',
            },
            'triggers': {
              'track pageview': {
                'on': 'visible',
                'request': 'pageview',
              },
            },
          }) }}
        />
      </amp-analytics>
    ),
  },

  tns: {
    default: ({ account, tmsec }, i) => account && tmsec ? ( // eslint-disable-line react/prop-types
      <Fragment key={account + tmsec + i}>
        <script dangerouslySetInnerHTML={{
          __html: oneLine`
          (function(win, doc, cb){
            (win[cb] = win[cb] || []).push(function() {
              try {
                tnsCounter${account[0].toUpperCase() + account.slice(1)} = new TNS.TnsCounter({
                'account':'${account}',
                'tmsec': '${tmsec}'
                });
              } catch(e){}
            });

            var tnsscript = doc.createElement('script');
            tnsscript.type = 'text/javascript';
            tnsscript.async = true;
            tnsscript.src = ('https:' == doc.location.protocol ? 'https:' : 'http:') +
                '//www.tns-counter.ru/tcounter.js';
            var s = doc.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(tnsscript, s);
          })(window, this.document,'tnscounter_callback');`,
        }}
        />
        <noscript dangerouslySetInnerHTML={{
          __html: oneLine`
          <img src='https://www.tns-counter.ru/V13a****${account}/ru/UTF-8/tmsec=${tmsec}/' style='position:absolute; left:-9999px' alt=''/>
        `,
        }}
        />
      </Fragment>
    ) : null,
    // eslint-disable-next-line react/prop-types
    amp: ({ account, tmsec }, i) => account && tmsec ? (
      <amp-pixel
        key={account + tmsec + i}
        src={`//tns-counter.ru/V13a****${account}/ru/UTF-8/tmsec=${tmsec}-amp/RANDOM`}
        layout='nodisplay'
      />
    ) : null,
  },

  mediascope: {
    default: (id, i) => (
      <Fragment key={id + i}>
        <script dangerouslySetInnerHTML={{
          __html: oneLine`
          var updateMediascopeCounter;
          (updateMediascopeCounter = function() {
            (new Image()).src = 'https://www.tns-counter.ru/V13a***R>'
              + document.referrer.replace(/\\*/g,'%2a') + '*rambler_ad/ru/UTF-8/tmsec=${id}'
              + Math.round(Math.random()*1E9);
            (new Image()).src = 'https://www.tns-counter.ru/V13a***R>'
              + document.referrer.replace(/\\*/g,'%2a') + '*rambler_ad/ru/UTF-8/tmsec=rambler_cid1100104-posid2155079/'
              + Math.round(Math.random()*1E9);
          })();`,
        }}
        />
        <noscript dangerouslySetInnerHTML={{
          __html: oneLine`
          <img src='http://www.tns-counter.ru/V13a****rambler_ad/ru/UTF-8/tmsec=${id}' width='1' height='1' alt='' />
          <img src='http://www.tns-counter.ru/V13a****rambler_ad/ru/UTF-8/tmsec=rambler_cid1100104-posid2155079/' width='1' height='1' alt='' />
        `,
        }}
        />
      </Fragment>
    ),

    amp: (id, i) => (
      <Fragment key={id + i}>
        <amp-pixel
          src={`//tns-counter.ru/V13a****rambler_ad/ru/UTF-8/tmsec=${id}-amp/RANDOM`}
          layout='nodisplay'
        />
        <amp-pixel
          src='//tns-counter.ru/V13a****rambler_ad/ru/UTF-8/tmsec=rambler_cid1100104-posid2155079/-amp/RANDOM'
          layout='nodisplay'
        />
      </Fragment>
    ),
  },

  top100: {
    default: (id, options) => {
      const counterOptions = JSON.stringify({
        project: id,
        ...options,
      });

      return (
        <Fragment key={id}>
          <Helmet>
            <script>{oneLine`
            (function(w, d, c) {
              (w[c] = w[c] || []).push(function() {
                var options = ${counterOptions};
                try {
                  w.top100Counter = new top100(options);
                } catch (e) {
                }
              });

              var n = d.getElementsByTagName("script")[0],
                      s = d.createElement("script"),
                      f = function() {
                        n.parentNode.insertBefore(s, n);
                      };
              s.type = "text/javascript";
              s.async = true;
              s.src =
                      (d.location.protocol == "https:" ? "https:" : "http:") +
                      "//st.top100.ru/top100/top100.js";

              if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
              } else {
                f();
              }
            })(window, document, "_top100q");`}
            </script>
          </Helmet>
          <noscript dangerouslySetInnerHTML={{
            __html: oneLine`
            <img src='//counter.rambler.ru/top100.cnt?pid=${id}' style='position:absolute; left:-9999px' alt=''/>
          `,
          }}
          />
        </Fragment>
      );
    },
    amp: id => (
      <amp-analytics
        type='top100'
        id='top100'
        config='https://kraken.rambler.ru/amp/config.json'
        key={id}
      >
        <script type='application/json' dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            'vars': {
              'pid': id,
            },
          }),
        }}
        />
      </amp-analytics>
    ),
  },

  yandexMetrika: {
    default: (params, visitParams) => {
      /**
       * Запуск инициализации счетчиков, вебвизор подключается только
       * к одному счетчику согласно документации:
       * https://yandex.ru/support/metrika/code/install-several-counters.html
       */
      const getId = (param) => param.id || param;

      const hasVisitParams = !!visitParams && Object.keys(visitParams).length > 0;

      const init = params.map(param => {
        return `ym(${getId(param)}, 'init', {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          userParams: {
            UserID: getUid(),
          },
          ${param.webvisor ? 'webvisor: true' : ''}
          ${hasVisitParams ? 'params:' + JSON.stringify(visitParams) : ''}
        });`;
      });

      const images = params.map(param => {
        return `<img src='https://mc.yandex.ru/watch/${getId(param)}' style='position:absolute; left:-9999px;' alt='' />`;
      });

      return (
        <Fragment key={params.join('')}>
          <Helmet>
            <script>{oneLine`
            function getUid() {
              const result = document.cookie.match(/(?:^|; )uid=(.*?)(?:;|$)/);
              return result && result[1];
            }
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://cdn.jsdelivr.net/npm/yandex-metrica-watch/tag.js", "ym");
            ${init.join('')} `}
            </script>
          </Helmet>
          <noscript dangerouslySetInnerHTML={{
            __html: oneLine`<div>${images.join('')}</div>`,
          }}
          />
        </Fragment>
      );
    },
    // https://yandex.ru/support/metrika/code/install-counter-amp.html
    amp: ids => [].concat(ids).map(id => (
      <amp-analytics type='metrika' key={id}>
        <script type='application/json' dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            'vars': {
              'counterId': id.id || id,
            },
            'triggers': {
              'trackScrollThrough': {
                'on': 'amp-next-page-scroll',
                'request': 'pageview',
              },
              'notBounce': {
                'on': 'timer',
                'timerSpec': {
                  'immediate': false,
                  'interval': 15,
                  'maxTimerLength': 16,
                },
                'request': 'notBounce',
              },
              'trackPageview': {
                'on': 'visible',
                'request': 'pageview',
              },
            },
          }) }}
        />
      </amp-analytics>
    )),
  },

  mailru: (id, i) => (
    <Fragment key={id + i}>
      <script dangerouslySetInnerHTML={{
        __html: oneLine`
        var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({id: ${id}, type: "pageView", start: (new Date()).getTime()});
        (function (d, w, id) {
          if (d.getElementById(id)) return;
          var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
          ts.src = "https://top-fwz1.mail.ru/js/code.js";
          var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
          if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
        })(document, window, "topmailru-code");`,
      }}
      />
      <noscript dangerouslySetInnerHTML={{
        __html: oneLine`
        <div><img src='https://top-fwz1.mail.ru/counter?id=${id};js=na' style='border:0;position:absolute;left:-9999px;' alt='Top.Mail.Ru' /></div>
      `,
      }}
      />
    </Fragment>
  ),

  rcm: (id, i) => (
    <script key={id + i} dangerouslySetInnerHTML={{
      __html: oneLine`
      (function (w, d, c) {
          w[c] = w[c] || function () {
            (w[c].q = w[c].q || []).push(arguments);
          }, w[c].l = 1 * new Date();

          var n = d.getElementsByTagName("script")[0],
                  s = d.createElement("script"),
                  f = function () { n.parentNode.insertBefore(s, n); };
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://rcmjs.rambler.ru/static/recommender.js";
          if (w.opera == "[object Opera]") {
              d.addEventListener("DOMContentLoaded", f, false);
          } else { f(); }
      })(window, document, "rcm");`,
    }}
    />
  ),

  gemius: (id) => {
    return (
      <script key={`gemius-${id}`} dangerouslySetInnerHTML={{
        __html: oneLine`
        var pp_gemius_identifier = 'nSzgvPuSG0jfABCp5jRWjnZHXmDBvAdjV.RMPABTRG3.57';
        function gemius_pending(i) { window[i] = window[i] || function() {var x = window[i+'_pdata'] = window[i+'_pdata'] || []; x[x.length]=arguments;};};gemius_pending('gemius_hit'); gemius_pending('gemius_event'); gemius_pending('pp_gemius_hit'); gemius_pending('pp_gemius_event');(function(d,t) {try {var gt=d.createElement(t),s=d.getElementsByTagName(t)[0],l='http'+((location.protocol=='https:')?'s':''); gt.setAttribute('async','async');gt.setAttribute('defer','defer'); gt.src=l+'://gamd.hit.gemius.pl/xgemius.js'; s.parentNode.insertBefore(gt,s);} catch (e) {}})(document,'script');`,
      }}
      />
    );
  },
};
/* eslint-enable react/no-danger */
